import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Table, Button, Icon } from "semantic-ui-react";
import { toast, ToastContainer } from "react-toastify";
import { LoadingSpinner, BasicModal, ConfirmDialog } from "../../../Shared";
import { InjuryNature } from "../../../../api";
import { useLanguage } from "../../../../contexts";
import { InjuryNatureForm } from "../InjuryNatureForm/InjuryNatureForm";
import searchSvg from "../../../../assets/svg/search.svg";
import "./ListInjuryNatures.scss";

const ctrl = new InjuryNature();

export function ListInjuryNatures({ active, reload, onReload }) {
  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const [items,       setItems]       = useState(null);
  const [filtered,    setFiltered]    = useState([]);
  const [search,      setSearch]      = useState("");
  const [showModal,   setShowModal]   = useState(false);
  const [selected,    setSelected]    = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMsg,  setConfirmMsg]  = useState("");
  const [isDelete,    setIsDelete]    = useState(false);
  const [rowMenu,     setRowMenu]     = useState(null); // { id, top, left, openUp } | null

  useEffect(() => {
    if (!rowMenu) return;
    const handler = (e) => {
      if (!e.target.closest(".injury-natures-list__row-menu, .injury-natures-list__row-menu-list")) setRowMenu(null);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [rowMenu]);

  const toggleRowMenu = (id, e) => {
    if (rowMenu?.id === id) { setRowMenu(null); return; }
    const rect = e.currentTarget.getBoundingClientRect();
    const menuHeight = 150;
    const openUp = rect.bottom + menuHeight > window.innerHeight;
    setRowMenu({
      id,
      left: rect.right - 170,
      top: openUp ? rect.top - 4 : rect.bottom + 4,
      openUp,
    });
  };

  useEffect(() => {
    (async () => {
      try {
        setItems(null);
        const res = await ctrl.getInjuryNatures(active);
        setItems(res); setFiltered(res);
      } catch { setItems([]); setFiltered([]); }
    })();
  }, [active, reload]);

  useEffect(() => {
    if (!items) return;
    if (!search) { setFiltered(items); return; }
    const q = search.toLowerCase();
    setFiltered(items.filter((i) => i.name?.toLowerCase().includes(q)));
  }, [search, items]);

  const openCreate = () => { setSelected(null); setShowModal(true); };
  const openEdit   = (i) => { setSelected(i);   setShowModal(true); };

  const openToggle = (i) => { setSelected(i); setIsDelete(false); setConfirmMsg(`¿${i.active ? t("deactivate") : t("activate")} "${i.name}"?`); setShowConfirm(true); };
  const openDelete = (i) => { setSelected(i); setIsDelete(true);  setConfirmMsg(`¿${t("delete")} "${i.name}"?`);                                 setShowConfirm(true); };

  const handleToggle = async () => {
    try { await ctrl.updateInjuryNature(selected._id, { active: !selected.active }); toast.success(selected.active ? t("deactivated") : t("activated")); setShowConfirm(false); onReload(); }
    catch { toast.error(t("error_updating")); }
  };
  const handleDelete = async () => {
    try { await ctrl.deleteInjuryNature(selected._id); toast.success(t("deleted")); setShowConfirm(false); onReload(); }
    catch (err) { toast.error(err?.msg || t("error_deleting")); }
  };

  if (items === null) return <LoadingSpinner />;

  return (
    <div className="injury-natures-list">
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="injury-natures-list__card">
        <div className="injury-natures-list__filters">
          <div className="search-user-wrapper">
            <img src={searchSvg} alt="search" className="search-user-icon" />
            <input
              className="search-user-input"
              placeholder={`${t("search")}...`}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <Button icon className="add-injury-nature-btn" title={t("create")} onClick={openCreate}>
            <Icon name="plus" />
          </Button>
        </div>

        {filtered.length === 0 ? (
          <div className="list-empty-state">
                <Icon name="folder open outline" className="list-empty-state__icon" />
                <p className="list-empty-state__text">{t("no_results")}</p>
              </div>
        ) : (
          <div className="injury-natures-list__tbl-scroll">
            <Table className="injury-natures-table unstackable rtable-cards row-hover">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>{t("name")}</Table.HeaderCell>
                  <Table.HeaderCell textAlign="right"></Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {filtered.map((i) => (
                  <Table.Row key={i._id}>
                    <Table.Cell data-label={t("name")}>{i.name}</Table.Cell>
                    <Table.Cell textAlign="center" data-label="" className="injury-natures-table__actions" onClick={(e) => e.stopPropagation()}>
                      <div className="injury-natures-list__row-menu">
                        <button type="button" className="injury-natures-list__row-menu-btn" onClick={(e) => toggleRowMenu(i._id, e)} aria-label={t("actions")}>
                          <Icon name="ellipsis vertical" />
                        </button>
                      </div>
                      {rowMenu?.id === i._id && ReactDOM.createPortal(
                        <div
                          className="injury-natures-list__row-menu-list"
                          style={{
                            position: "fixed",
                            top: rowMenu.top,
                            left: rowMenu.left,
                            transform: rowMenu.openUp ? "translateY(-100%)" : "none",
                          }}
                        >
                          <button onClick={() => { openEdit(i); setRowMenu(null); }}>
                            <Icon name="pencil" />{t("edit")}
                          </button>
                          <button onClick={() => { openToggle(i); setRowMenu(null); }}>
                            <Icon name={i.active ? "ban" : "check"} />{i.active ? t("deactivate") : t("activate")}
                          </button>
                          <button className="injury-natures-list__row-menu-item--danger" onClick={() => { openDelete(i); setRowMenu(null); }}>
                            <Icon name="trash" />{t("delete")}
                          </button>
                        </div>,
                        document.body
                      )}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
          </div>
        )}
      </div>

      <BasicModal show={showModal} close={() => setShowModal(false)} title={selected ? `${t("edit")}: ${selected.name}` : t("new_injury_nature")} size="small" className="catalog-modal">
        <InjuryNatureForm item={selected} close={() => setShowModal(false)} onReload={onReload} />
      </BasicModal>

      <ConfirmDialog
        open={showConfirm}
        title={isDelete ? t("delete") : (selected?.active ? t("deactivate") : t("activate"))}
        message={confirmMsg}
        onCancel={() => setShowConfirm(false)}
        onConfirm={isDelete ? handleDelete : handleToggle}
        confirmLabel={t("accept")}
        cancelLabel={t("cancel")}
        confirmDanger={isDelete}
      />
    </div>
  );
}
